module.exports = __webpack_public_path__ + "/images/mockup-llista-it.fff3573.png";